import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { CardHeader } from "../../../components/cards";
import { Header } from "../../../components/header";
import { SendIcon } from "../../../components/icons";

import { useRound } from "../hooks";

type IRoundParams = {
  id: string;
};

export const Round: React.FC = () => {
  const { id } = useParams<IRoundParams>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/rounds");
    }
  }, []);

  const { data } = useRound(+id!);

  return (
    <>
      <Header
        title={`Round`}
        subtitle={`${data?.round?.result?.site?.name}`}
        buttons={[
          {
            actionText: "Modifier",
            bgColor: "indigo",
            textColor: "white",
            link: `/round/${id}/update`,
            icon: <SendIcon />,
          },
        ]}
      />

      <div className="main-container">
        <section className="section ">
          <div className=" element">
            <div className="card">
              <CardHeader title={data?.round?.result?.site?.name ?? ""} />
            </div>
          </div>

          <div className="element">
            <div className="card"></div>
          </div>
        </section>
      </div>
    </>
  );
};
